export const MappingTypes = {
	Contact: 0,
	Metadata: 1,
	CallWindows: 2,
};
